<template>
	<section class="section-table">
		<div class="header-table">
			<div class="search-container">
				<feather
					class="refreshtable"
					:class="isLoading === true ? 'animation-refresh' : 'stop'"
					type="refresh-cw"
					size="18px"
					@click="!isLoading ? refreshTable() : null"
				/>
				<search width="70%" height="35px" @searchtext="(searchTerm = $event), filter()" />
			</div>
			<div class="right-container">
				<div class="select-rows-qt">
					<select
						v-model="rowsperpagechange"
						class="select-container"
						title="Selecionar quantidade de linhas"
						@change="(rowsperpage = rowsperpagechange), $emit('pagelimit', rowsperpagechange)"
					>
						<option :value="10">
							10 Linhas -
							{{ `${userPageStatus} Até ${rowsperpageCustom} /` }}
							Total: {{ totalpages }}
						</option>
						<option :value="30">
							30 Linhas -
							{{ `${userPageStatus} Até ${rowsperpageCustom} /` }}
							Total: {{ totalpages }}
						</option>
						<option :value="50" selected>
							50 Linhas -
							{{ `${userPageStatus} Até ${rowsperpageCustom} /` }}
							Total: {{ totalpages }}
						</option>
						<option :value="100">
							100 Linhas -
							{{ `${userPageStatus} Até ${rowsperpageCustom} /` }}
							Total: {{ totalpages }}
						</option>
					</select>
				</div>
				<Export :data="data" :filters="filterspedidos" />
				<kfilter
					:filter-visibility="filterVisibility"
					@open-filter="filterVisibility = true"
					@apply="(filterVisibility = !filterVisibility), filter()"
					@clear="clearFilter"
				>
					<template #container>
						<div class="container-filter">
							<div class="situation-pedido-box">
								<b-checkbox
									v-model="situationcheckbox"
									:disabled="verifySelectedGuide() || statuscheckbox"
									size="is-small"
									class="checkbox-situation-pedido"
								>
									Situação
								</b-checkbox>
								<div v-if="situationcheckbox" class="situation-box-input">
									<div class="grouped-situation-pedido-input">
										<feather type="corner-down-right" size="18" class="arrow-indicator" />
										<treeselect
											v-model="situation"
											class="treeselectcheck"
											:multiple="true"
											:options="situationsOpt"
										/>
									</div>
								</div>
							</div>
							<div class="situation-pedido-box">
								<b-checkbox
									v-model="statuscheckbox"
									size="is-small"
									class="checkbox-situation-pedido"
								>
									Status
								</b-checkbox>
								<div v-if="statuscheckbox" class="situation-box-input">
									<div class="grouped-situation-pedido-input">
										<feather type="corner-down-right" size="18" class="arrow-indicator" />
										<treeselect
											v-model="statusdata"
											class="treeselectcheck"
											:multiple="false"
											:options="statusOptions"
										/>
									</div>
								</div>
							</div>
							<div class="situation-pedido-box">
								<b-checkbox
									v-model="dataCriacaoCheckbox"
									size="is-small"
									class="checkbox-situation-pedido"
								>
									Data de Criação
								</b-checkbox>
								<div v-if="dataCriacaoCheckbox" class="situation-box-input">
									<div class="grouped-situation-pedido-input">
										<b-select
											v-model="dateSelected"
											placeholder="Select a character"
											size="is-small"
											class="dateSelect"
											expanded
										>
											<option :value="0" selected>está entre</option>
										</b-select>
									</div>
									<div v-if="dateSelected === 0" class="double-input-date">
										<feather type="corner-down-right" size="18" class="arrow-indicator" />
										<b-input
											v-model="inputDateBetween[0].dtsituacao_ini"
											class="double-input"
											type="date"
											size="is-small"
										/>
										<b-input
											v-model="inputDateBetween[0].dtsituacao_fin"
											size="is-small"
											class="double-input"
											type="date"
										/>
									</div>
								</div>
							</div>
							<div class="situation-pedido-box">
								<b-checkbox
									v-model="fdateCheckbox"
									size="is-small"
									class="checkbox-situation-pedido"
								>
									Data de Finalização
								</b-checkbox>
								<div v-if="fdateCheckbox" class="situation-box-input">
									<div class="grouped-situation-pedido-input">
										<b-select
											v-model="fDateSelect"
											placeholder="Select a character"
											size="is-small"
											class="dateSelect"
											expanded
										>
											<option :value="0">está entre</option>
										</b-select>
									</div>
									<div v-if="fDateSelect === 0" class="double-input-date">
										<feather type="corner-down-right" size="18" class="arrow-indicator" />
										<b-input
											v-model="inputFDateBetween[0].dtsituacao_ini"
											class="double-input"
											type="date"
											size="is-small"
										/>
										<b-input
											v-model="inputFDateBetween[0].dtsituacao_fin"
											size="is-small"
											class="double-input"
											type="date"
										/>
									</div>
								</div>
							</div>
							<div class="situation-pedido-box">
								<b-checkbox
									v-model="sitdateCheckbox"
									size="is-small"
									class="checkbox-situation-pedido"
								>
									Data da Situação
								</b-checkbox>
								<div v-if="sitdateCheckbox" class="situation-box-input">
									<div class="grouped-situation-pedido-input">
										<b-select
											v-model="sitDateSelect"
											placeholder="Select a character"
											size="is-small"
											class="dateSelect"
											expanded
										>
											<option :value="0">está entre</option>
										</b-select>
									</div>
									<div v-if="sitDateSelect === 0" class="double-input-date">
										<feather type="corner-down-right" size="18" class="arrow-indicator" />
										<b-input
											v-model="inputSitDateBetween[0].dtsituacao_ini"
											class="double-input"
											type="date"
											size="is-small"
										/>
										<b-input
											v-model="inputSitDateBetween[0].dtsituacao_fin"
											size="is-small"
											class="double-input"
											type="date"
										/>
									</div>
								</div>
							</div>
							<div class="situation-pedido-box">
								<b-checkbox
									v-model="clienteCheckbox"
									size="is-small"
									class="checkbox-situation-pedido"
								>
									Cliente
								</b-checkbox>
								<div v-if="clienteCheckbox" class="situation-box-input">
									<div class="grouped-situation-pedido-input">
										<feather type="corner-down-right" size="18" class="arrow-indicator" />
										<treeselect
											v-model="pessoa_id"
											class="treeselectcheck"
											:multiple="true"
											:async="true"
											:load-options="loadClientes"
										/>
									</div>
								</div>
							</div>
							<div class="situation-pedido-box">
								<b-checkbox
									v-model="fpagamentoCheckbox"
									size="is-small"
									class="checkbox-situation-pedido"
								>
									Forma de Pagamento
								</b-checkbox>
								<div v-if="fpagamentoCheckbox" class="situation-box-input">
									<div class="grouped-situation-pedido-input">
										<feather type="corner-down-right" size="18" class="arrow-indicator" />
										<treeselect
											v-model="formpgto_id"
											class="treeselectcheck"
											:multiple="true"
											:options="paymentOptions"
										/>
									</div>
								</div>
							</div>
							<div class="situation-pedido-box">
								<b-checkbox
									v-model="empresasCheckbox"
									size="is-small"
									class="checkbox-situation-pedido"
								>
									Empresas
								</b-checkbox>
								<div v-if="empresasCheckbox" class="situation-box-input">
									<div class="grouped-situation-pedido-input">
										<feather type="corner-down-right" size="18" class="arrow-indicator" />
										<treeselect
											v-model="empresa_id"
											class="treeselectcheck"
											:multiple="true"
											:options="empresasOptions"
										/>
									</div>
								</div>
							</div>
						</div>
					</template>
				</kfilter>
			</div>
		</div>
		<b-table
			v-if="data.length > 0"
			ref="table"
			:data="data"
			hoverable
			backend-pagination
			custom-detail-row
			detail-key="name"
			focusable
			backend-sorting
			:selected.sync="selected"
			:current-page="currentpage"
			:paginated="myData.length === 0 ? false : true"
			pagination-size="is-small"
			:per-page="rowsperpage"
			:loading="isLoading"
			:total="totalpages"
			striped
			:sticky-header="true"
			@sort="(orderby, direction) => filter(false, orderby, direction)"
			@page-change="pageChange($event)"
		>
			<b-table-column
				v-slot="props"
				field="details"
				label="Ações"
				centered
				header-class="custom-header"
			>
				<router-link
					title="Ver detalhes"
					class="view-more-link"
					:to="`/order/` + props.row.id + `/details`"
				>
					<feather :style="{ color: '#003566' }" type="info" size="15" />
				</router-link>
				<button
					v-if="statusdata === 1 && props.row.deleted_at"
					title="Restaurar"
					:style="{ color: '#d90429' }"
					class="restore-trash"
					@click="$emit('restoreorder', props.row.id)"
				>
					<feather class="icone" type="refresh-ccw" size="15" />
				</button>
			</b-table-column>
			<b-table-column
				v-slot="props"
				field="id"
				label="ID"
				numeric
				centered
				sortable
				header-class="custom-header"
				:default-sort="['id', 'desc']"
			>
				<h1 :ref="'a' + props.row.id" class="pedido_id_small">
					{{ props.row.id }}
				</h1>
			</b-table-column>
			<b-table-column
				v-slot="props"
				label="Situação"
				field="situacao"
				header-class="custom-header"
				centered
				sortable
			>
				<Tag :data="props.row.situacao" />
			</b-table-column>
			<b-table-column
				v-slot="props"
				field="data_ultima_situacao"
				label="DTA. Última Situacao"
				sortable
				header-class="custom-header"
			>
				<h1 class="row-text">
					{{
						dateTimetoDate(props.row.data_ultima_situacao) === 'Vazio'
							? '~'
							: dateTimetoDate(props.row.data_ultima_situacao)
					}}
				</h1>
				<h2
					v-if="dateTimetoTime(props.row.data_ultima_situacao) !== 'Vazio'"
					class="table-subtitle"
				>
					as {{ dateTimetoTime(props.row.data_ultima_situacao) }}
				</h2>
			</b-table-column>

			<b-table-column
				v-slot="props"
				field="created_at"
				label="Data Criação"
				sortable
				header-class="custom-header"
			>
				<h1 class="row-text">
					{{ dateTimetoDate(props.row.created_at) }}
				</h1>
				<h2 class="table-subtitle">as {{ dateTimetoTime(props.row.created_at) }}</h2>
			</b-table-column>

			<b-table-column
				v-slot="props"
				field="data_envio"
				label="Dta. Envio"
				header-class="custom-header"
			>
				<h1 class="row-text">
					{{
						dateTimetoDate(props.row.data_envio) === 'Vazio'
							? '~'
							: dateTimetoDate(props.row.data_envio)
					}}
				</h1>
				<h2 v-if="dateTimetoTime(props.row.data_envio) !== 'Vazio'" class="table-subtitle">
					as {{ dateTimetoTime(props.row.data_envio) }}
				</h2>
			</b-table-column>

			<b-table-column
				v-slot="props"
				field="cliente_id"
				label="Cli. Id"
				header-class="custom-header"
				centered
				sortable
			>
				<h1 class="pedido_id_small">
					{{ props.row.cliente_id ? props.row.cliente_id : '~' }}
				</h1>
			</b-table-column>

			<b-table-column
				v-slot="props"
				field="nomerazao"
				label="Cli. Razão Social"
				header-class="custom-header"
				sortable
			>
				<template>
					<h1 class="row-text">
						{{ props.row.nomerazao }}
					</h1>
				</template>
			</b-table-column>
			<b-table-column
				v-slot="props"
				field="integracao_id"
				label="ID Integração"
				header-class="custom-header"
				centered
				sortable
			>
				<h1 class="pedido_id_small">
					{{ props.row.integracao_id ? props.row.integracao_id : '~' }}
				</h1>
			</b-table-column>

			<b-table-column
				v-slot="props"
				field="empresa_fantasia"
				label="Emp. Fantasia"
				header-class="custom-header"
				sortable
			>
				<h1 class="row-text">
					{{ props.row.empresa_fantasia }}
				</h1>
			</b-table-column>

			<b-table-column
				v-slot="props"
				field="empresa_id"
				label="Emp. Id"
				sortable
				header-class="custom-header"
			>
				<h1 class="row-text">
					{{ props.row.empresa_id }}
				</h1>
			</b-table-column>

			<b-table-column
				v-slot="props"
				field="formpgto_desc"
				label="Pagamento"
				sortable
				header-class="custom-header"
			>
				<h1 class="row-text">
					{{ props.row.formpgto_desc }}
				</h1>
				<h2 class="table-subtitle">
					{{ props.row.condpgto_desc }}
				</h2>
			</b-table-column>

			<b-table-column
				v-slot="props"
				field="tabvnd_desc"
				label="Tab. Venda"
				sortable
				header-class="custom-header"
			>
				<h1 class="row-text">
					{{ props.row.tabvnd_desc }}
				</h1>
			</b-table-column>

			<b-table-column
				v-slot="props"
				field="nomerazao"
				label="Enviado por"
				header-class="custom-header"
				sortable
			>
				<template>
					<h1 class="row-text">
						{{ props.row.tipo_usu_finaliza }}
					</h1>
				</template>
			</b-table-column>

			<b-table-column
				v-slot="props"
				field="vltTotalPedido"
				label="Valor Total"
				header-class="custom-header"
			>
				<h1 class="row-text">
					{{ transformToBrlNoSymbol(parseFloat(props.row.vlrtotalpedido || 0).toFixed(2)) }}
				</h1>
				<h2 class="table-subtitle">BRL</h2>
			</b-table-column>
		</b-table>
		<Empty v-if="myData.length === 0 && isLoading === false" />
	</section>
</template>

<script>
import { ASYNC_SEARCH, Treeselect } from '@riophae/vue-treeselect';
import kfilter from '../filter/custom';
import search from '../search/index';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import Empty from '../empty/index';
import * as ecAxios from '../../../util/ecAxios';
import global from '../../../mixins/global';
import Tag from '../tags/situationped';
import Export from '../miscellaneous/exportped';

export default {
	components: {
		kfilter,
		Treeselect,
		search,
		Empty,
		Tag,
		Export,
	},
	mixins: [global],
	props: {
		totalpages: {
			type: Number,
			default: 0,
		},
		selectedguide: {
			type: Number,
			default: null,
		},
		currentpage: {
			type: Number,
			default: 1,
		},
		data: {
			type: Array,
			default: () => [],
		},
		isLoading: {
			type: Boolean,
			default: true,
		},
		columnsVisible: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			dataCriacaoCheckbox: false,
			situation: [],
			statuscheckbox: false,
			statusdata: false,
			statusOptions: [
				{
					id: 1,
					label: 'Deletado',
				},
				{
					id: 2,
					label: 'Lixeira',
				},
			],
			filterspedidos: {},
			fdateCheckbox: false,
			fDateSelect: 0,
			empresasOptions: [],
			inputFDateBetween: [{ dtsituacao_ini: '', dtsituacao_fin: '' }],
			empresasCheckbox: false,
			paymentOptions: [],
			clienteCheckbox: false,
			pessoa_id: [],
			formpgto_id: [],
			empresa_id: [],
			fpagamentoCheckbox: false,
			situacoeslog: null,
			dateSelected: 0,
			inputDateBetween: [{ dtsituacao_ini: '', dtsituacao_fin: '' }],
			situationsOpt: [
				{
					id: 0,
					label: 'Salvo',
				},
				{
					id: 1,
					label: 'Finalizado',
				},
				{
					id: 2,
					label: 'Integrado',
				},
				{
					id: 3,
					label: 'Inválido',
				},
				{
					id: 4,
					label: 'Em Análise',
				},
				{
					id: 5,
					label: 'Liberado',
				},
				{
					id: 6,
					label: 'Faturado',
				},
				{
					id: 7,
					label: 'Cancelado',
				},

				{
					id: 8,
					label: 'Transporte',
				},
				{
					id: 9,
					label: 'Entregue',
				},

				{
					id: 10,
					label: 'Aguardando Pagamento',
				},
				{
					id: 1,
					label: 'Em rota',
				},
			],
			filterVisibility: false,
			situationcheckbox: false,
			inputSitDateBetween: [{ dtsituacao_ini: '', dtsituacao_fin: '' }],
			sitDateSelect: 0,
			sitdateCheckbox: false,
			tabselected: '',
			rowsperpage: 50,
			rowsperpagechange: 50,
			userPageStatus: 1,
			pagenumber: 1,
			lastpage: 1,
			rowsperpageCustom: 50,
			selected: {},
			showDetailIcon: true,
		};
	},
	computed: {
		myData() {
			return this.data;
		},
	},
	watch: {
		selectedguide() {
			if (this.selectedguide < 0) {
				this.situation = null;
			} else {
				this.situation = [this.selectedguide];
			}
			this.verifySelectedGuide();
		},
		rowsperpagechange() {
			this.pageChange(this.lastpage);
		},
		selected(e) {
			this.$nextTick(() => {
				this.focustTable(`a${e.id}`);
			});
		},
	},
	mounted() {
		ecAxios
			.connection()
			.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_FORMAS_PAGAMENTO}`, {})
			.then((response) => {
				if (!response.data.error) {
					response.data.formpgtos.forEach((element) => {
						this.paymentOptions.push({
							id: element.id,
							label: element.descricao.toUpperCase(),
						});
					});
				}
			})
			.catch((err) => {
				this.$buefy.notification.open({
					message: err,
					type: 'is-danger',
				});
			});
		// Empresas
		ecAxios
			.connection()
			.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_EMPRESA}`, {})
			.then((response) => {
				if (!response.data.error) {
					response.data.empresas.forEach((element) => {
						this.empresasOptions.push({
							id: element.id,
							label: `${element.fantasia} | CPF/CNPJ:${element.cpfcnpj}`,
						});
					});
				}
			})
			.catch((err) => {
				this.$buefy.notification.open({
					message: err,
					type: 'is-danger',
				});
			});
	},
	created() {
		if (localStorage.getItem('filters')) {
			const filterDate = JSON.parse(localStorage.getItem('filters'));
			this.filterspedidos = filterDate;
			this.situation = filterDate.situacao;
			this.situacoeslog = filterDate.situacoeslog;
			this.empresa_id = filterDate.empresa_id;
			this.pessoa_id = filterDate.pessoa_id;
			this.formpgto_id = filterDate.formpgto_id;
			this.situationcheckbox = filterDate.situationcheckbox;
			this.fdateCheckbox = filterDate.fdateCheckbox;
			this.fpagamentoCheckbox = filterDate.fpagamentoCheckbox;
			this.empresasCheckbox = filterDate.empresasCheckbox;
			this.clienteCheckbox = filterDate.clienteCheckbox;
			this.inputDateBetween = filterDate.inputDateBetween;
			this.inputFDateBetween = filterDate.inputFDateBetween;
			this.statuscheckbox = filterDate.statuscheckbox;
			this.statusdata = filterDate.statusdata;
			this.inputSitDateBetween = filterDate.inputSitDateBetween;
			this.sitdateCheckbox = filterDate.sitdateCheckbox;
		}
		this.filter(true);
	},
	methods: {
		verifySelectedGuide() {
			if (this.selectedguide >= 0) {
				this.situationcheckbox = false;
				return true;
			}
			return false;
		},
		focustTable(refId = 'a139') {
			this.$refs[refId].scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
		},
		clearFilter() {
			this.$emit('clearFilter');
			this.situation = null;
			this.situacoeslog = null;
			this.situationcheckbox = false;
			this.sitdateCheckbox = false;
			this.sitDateSelect = 0;
			this.dataCriacaoCheckbox = false;
			this.inputDateBetween = [{ dtsituacao_ini: '', dtsituacao_fin: '' }];
			this.fDateSelect = 0;
			this.fdateCheckbox = false;
			this.inputFDateBetween = [{ dtsituacao_ini: '', dtsituacao_fin: '' }];
			this.inputSitDateBetween = [{ dtsituacao_ini: '', dtsituacao_fin: '' }];
			this.clienteCheckbox = false;
			this.pessoa_id = [];
			this.formpgto_id = [];
			this.fpagamentoCheckbox = false;
			this.empresa_id = [];
			this.empresasCheckbox = false;
			this.statuscheckbox = false;
			this.statusdata = null;
			localStorage.setItem(
				'filters',
				JSON.stringify({
					dataCriacaoCheckbox: this.dataCriacaoCheckbox,
					inputFDateBetween: this.inputFDateBetween,
					inputSitDateBetween: this.inputSitDateBetween,
					sitdateCheckbox: this.sitdateCheckbox,
					sitDateSelect: this.sitDateSelect,
					situationcheckbox: this.situationcheckbox,
					inputDateBetween: this.inputDateBetween,
					fdateCheckbox: this.fdateCheckbox,
					empresasCheckbox: this.empresasCheckbox,
					clienteCheckbox: this.clienteCheckbox,
					fpagamentoCheckbox: this.fpagamentoCheckbox,
					situacao: this.situation,
					situacoeslog: this.situacoeslog,
					formpgto_id: this.formpgto_id,
					empresa_id: this.empresa_id,
					pessoa_id: this.pessoa_id,
					statuscheckbox: this.statuscheckbox,
					statusdata: this.statusdata,
					searchTerm: this.searchTerm,
					limit: this.rowsperpagechange,
					offset: 0,
				})
			);
			this.$emit('filter', {
				limit: this.rowsperpagechange,
				offset: 0,
				pagenumber: 1,
			});
		},

		async loadClientes({ action, searchQuery, callback }) {
			const strlength = searchQuery.length;
			if (action === ASYNC_SEARCH && strlength >= 4) {
				/*    const userResult = []; */
				try {
					const url = `${process.env.VUE_APP_API_ADM_EC + api.env.EC_PESSOAS}`;
					const request = await ecAxios.connection().post(`${url}`, {
						searchTerm: searchQuery.toUpperCase(),
						offset: 0,
						limit: 5,
					});

					const { data } = request;
					if (data.error !== 1) {
						const { pessoas } = data;

						const newPessoas = pessoas.map((i) => ({
							label: `${i.nomerazao}
`,
							id: i.id,
						}));
						callback(null, newPessoas);
					} else {
						// eslint-disable-next-line no-throw-literal
						throw { message: data.message };
					}
				} catch (e) {
					this.$buefy.notification.open({
						message:
							e.message || 'Ops! Ocorreu um erro ao presseguir com a inativação do cadastro.',
						type: 'is-success',
					});
				}
			} else {
				const newPessoas = [];
				callback(null, newPessoas);
			}
		},
		removeNull(array) {
			return array.filter((x) => x !== null);
		},
		filterClean() {
			this.situacoeslog = [];
			const createdAt = {
				situacao: 0,
				dtsituacao_ini: this.inputDateBetween[0].dtsituacao_ini,
				dtsituacao_fin: this.inputDateBetween[0].dtsituacao_fin,
			};
			const finishDate = {
				situacao: 1,
				dtsituacao_ini: this.inputFDateBetween[0].dtsituacao_ini,
				dtsituacao_fin: this.inputFDateBetween[0].dtsituacao_fin,
			};

			const situacaoDate = {
				situacao: this.situation ? this.situation[0] : null,
				dtsituacao_ini: this.inputSitDateBetween[0].dtsituacao_ini,
				dtsituacao_fin: this.inputSitDateBetween[0].dtsituacao_fin,
			};

			if (createdAt.dtsituacao_ini.length > 0 && createdAt.dtsituacao_fin.length > 0) {
				this.situacoeslog[0] = createdAt;
			}

			if (finishDate.dtsituacao_ini.length > 0 && finishDate.dtsituacao_fin.length > 0) {
				this.situacoeslog[1] = finishDate;
			}
			if (situacaoDate.dtsituacao_ini.length > 0 && situacaoDate.dtsituacao_fin.length > 0) {
				this.situacoeslog[2] = situacaoDate;
			}

			if (this.situationcheckbox === false && this.selectedguide === -1) {
				this.situation = null;
			}

			if (this.dataCriacaoCheckbox === false) {
				this.situacoeslog[0] = null;
			}

			if (this.fdateCheckbox === false && this.dataCriacaoCheckbox === false) {
				this.situacoeslog[1] = null;
			}
			if (this.sitdateCheckbox === false) {
				this.situacoeslog[2] = null;
			}
			this.situacoeslog = this.removeNull(this.situacoeslog);

			if (this.empresasCheckbox === false) {
				this.empresa_id = null;
			}

			if (this.clienteCheckbox === false) {
				this.pessoa_id = null;
			}

			if (this.fpagamentoCheckbox === false) {
				this.formpgto_id = null;
			}
			if (this.statuscheckbox === false) {
				this.statusdata = null;
			} else {
				this.situation = null;
				this.situationcheckbox = false;
			}
		},
		refreshTable() {
			const filters = JSON.parse(localStorage.getItem('filters')) || null;
			this.$emit('reload', filters);
		},

		filter(first = false, orderby = null, direction = null) {
			this.filterClean();
			if (first === false) {
				localStorage.setItem(
					'filters',
					JSON.stringify({
						inputFDateBetween: this.inputFDateBetween,
						inputDateBetween: this.inputDateBetween,
						inputSitDateBetween: this.inputSitDateBetween,
						situationcheckbox: this.situationcheckbox,
						fdateCheckbox: this.fdateCheckbox,
						sitdateCheckbox: this.sitdateCheckbox,
						sitDateSelect: this.sitDateSelect,
						empresasCheckbox: this.empresasCheckbox,
						clienteCheckbox: this.clienteCheckbox,
						fpagamentoCheckbox: this.fpagamentoCheckbox,
						statuscheckbox: this.statuscheckbox,
						statusdata: this.statusdata,
						situacao: this.situation,
						situacoeslog: this.situacoeslog,
						formpgto_id: this.formpgto_id,
						empresa_id: this.empresa_id,
						pessoa_id: this.pessoa_id,
						searchTerm: this.searchTerm,
						limit: this.rowsperpagechange,
						offset: 0,
						orderby,
						direction,
					})
				);
			}

			const filterDate = localStorage.getItem('filters');
			this.$emit('filter', JSON.parse(filterDate));
		},
		pageChange(pagenumber) {
			let filterDate = {};
			this.pagenumber = pagenumber;
			this.filterClean();
			if (localStorage.getItem('filters')) {
				filterDate = JSON.parse(localStorage.getItem('filters'));
			} else {
				filterDate = {
					limit: this.rowsperpagechange,
					offset: 0,
					pagenumber: 1,
				};
			}
			filterDate.pagenumber = pagenumber;
			filterDate.offset = null;
			this.$emit('pagechange', filterDate);
			this.lastpage = pagenumber;
			this.rowsperpageCustom = pagenumber * this.rowsperpagechange + 1;
			this.userPageStatus = this.rowsperpageCustom - this.rowsperpagechange;
		},
		getStatusName(statusName) {
			return statusName.title;
		},
		toggle(row) {
			this.$refs.table.toggleDetails(row);
		},
		showContext(row, context) {
			this.selected = row;
			context.preventDefault();
			this.$refs.menu.open(context, row);
		},
	},
};
</script>
<style lang="scss" scoped>
.container-image-empty {
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
}

.custom-header {
	font-size: $header-size;
	font-weight: $header-weight;
	color: $header-color;
}
.text-empty {
	font-weight: bold;
	font-size: 14px;
	color: rgb(27, 3, 27);
}
.container-image-empty img {
	width: 35%;
}
.section-table {
	margin-bottom: 20px;
	background-color: #fff;
	padding-bottom: 10px;
	padding: 13px;
	border-radius: 5px;
}
.pedido_id_small {
	font-size: 12px;
}

.b-tabs {
	width: 100% !important;
}
.container-table {
	border-left: 1px solid #dbdbdb;
	border-right: 1px solid #dbdbdb;
	border-bottom: 1px solid #dbdbdb;
}

.abas-pedidos {
	width: 100%;
	display: flex;
	flex-direction: column;
}
.right-container {
	display: flex;
	align-items: center;
}
.title-counter-container {
	width: 100%;
	padding-right: 10px;
	padding-top: 10px;
	padding-bottom: 10px;
	margin-bottom: 10px;
	border-bottom: 1px solid #f2f0f9;
}
.title-counter-container h1 {
	font-size: 16px;
	color: #25213b;
}

.pedidos-tag {
	display: flex;
	width: 100%;
	justify-content: space-between;
}

.search-container {
	width: 60%;
	display: flex;
	align-items: center;
}
.refreshtable {
	margin-right: 20px;
	color: #00c9a7;
	cursor: pointer;
}

.header-table {
	display: flex;
	background-color: #fff;
	padding: 20px;
	justify-content: space-between;
}
.menu-row-icon {
	color: #8b83ba;
	padding-left: 10px;
	padding-right: 10px;
	font-weight: 500;
}

.menu-row-box-bottom {
	padding-top: 10px;
}
.menu-row-box {
	padding-bottom: 10px;
	border-bottom: 1px solid #f2f0f9;
}
.menu-row-option:hover {
	background-color: #f2f0f9 !important;
	color: #25213b !important;
	border-radius: 5px;
}

.menu-row-option:hover .danger {
	color: #dc3545 !important;
}

.menu-row-option:hover .check {
	color: #007f00;
}

.menu-row-option:hover .archive {
	color: #f77f00;
}

.menu-row-option {
	display: flex;
	align-items: center;
	margin-left: 5px;
	margin-right: 5px;
	padding: 10px;

	cursor: pointer;
}
.row-text {
	display: flex;
	color: $row-color;
	font-weight: $row-weight;
	margin-top: 2.5px;
	margin-bottom: 2.5px;
	font-size: $row-size;
}

.status0 .circle {
	background-color: #ffffff;
}
.status0 {
	background-color: #808080;
	color: #fff;
}

.status1 {
	background-color: #cdffcd;
	color: #007f00;
}
.status1 .circle {
	background-color: #007f00;
}

.status2 {
	background-color: #9521d848;
	color: #9521d8;
}

.status2 .circle {
	background-color: #9521d8;
}

.status3 {
	background-color: #e686206c;
	color: #e68520;
}
.status3 .circle {
	background-color: #e68520;
}

.status4 {
	background-color: #ff7b0038;
	color: #ff7b00;
}
.status4 .circle {
	background-color: #ff7b00;
}

.status5 {
	background-color: #7ddbbf42;
	color: #7ddbbf;
}
.status5 .circle {
	background-color: #7ddbbf;
}

.status6 {
	background-color: #461ca831;
	color: #471ca8;
}
.status6 .circle {
	background-color: #471ca8;
}

.status7 {
	background-color: #f8aaaa4b;
	color: #ea5455;
}
.status7 .circle {
	background-color: #ea5455;
}

.status {
	display: flex;
	align-items: center;
	border-radius: 8px;
	padding: 4px;
	justify-content: center;
	font-size: 10px;
	max-width: 90px;
	cursor: pointer;
}
.circle {
	margin-top: 1px;
	display: flex;
	width: 6px;
	height: 6px;
	margin-right: 5px;
	border-radius: 50%;
}
.table-subtitle {
	font-size: 10.5px;
	margin-bottom: 2.5px;
	font-weight: 400;
	color: #6e6893;
}
.view-more-link {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 5px;
	text-decoration: none;
}
.restore-trash {
	all: unset;
	margin-left: 5px;
	margin-right: 5px;
	cursor: pointer;
}
.icone {
	background-color: '#7159c1' !important;
}

.view-more-link h1 {
	padding: 5px;
	color: #56507e;
	font-size: 10px;
	border-radius: 2px;
	transition: 0.2s ease-in-out;
	white-space: nowrap;
}
.view-more-link h1:hover {
	color: #ffffff;
	background-color: #7e6ee457;
}

.dots {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	transition: 0.5s ease-in-out;
}
.dots:hover span {
	background-color: #574d8b;
}

.dots span {
	display: flex;
	width: 3px;
	height: 3px;
	border-radius: 50%;
	margin: 1px;
	background-color: #8b83ba;
}
.select-container {
	all: unset;
	border-radius: 0.25rem;
	cursor: pointer;
	border: 1px solid #e2e2e2;
	padding-top: 7px;
	padding-bottom: 7px;
	padding-left: 15px;
	padding-right: 15px;
	font-size: 12px;
	margin-right: 20px;
	color: rgb(98, 98, 98);
}
.situation-box-input {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}
.dateSelect {
	width: 100%;
	margin-top: 10px;
}
.situation-pedido-box {
	padding: 10px;
	margin-top: 10px;
	border-bottom: 1px solid #25213b1f;
}
.treeselectcheck {
	width: 100%;
	margin-left: 5px;
}
.grouped-situation-pedido-input {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
}
.double-input-date {
	display: flex;
	height: 30px;
	margin-top: 10px;
	width: 100%;
	align-items: center;
	justify-content: space-between;
}
.double-input {
	width: 45%;
}

.animation-refresh {
	-webkit-animation: rotating 2s linear infinite;
	-moz-animation: rotating 2s linear infinite;
	-ms-animation: rotating 2s linear infinite;
	-o-animation: rotating 2s linear infinite;
	animation: rotating 2s linear infinite;
}

@keyframes rotating {
	from {
		-ms-transform: rotate(0deg);
		-moz-transform: rotate(0deg);
		-webkit-transform: rotate(0deg);
		-o-transform: rotate(0deg);
		transform: rotate(0deg);
	}
	to {
		-ms-transform: rotate(360deg);
		-moz-transform: rotate(360deg);
		-webkit-transform: rotate(360deg);
		-o-transform: rotate(360deg);
		transform: rotate(360deg);
	}
}
.refreshtable {
	display: flex;
	margin-right: 20px;
	color: #00c9a7;
	cursor: pointer;
}
</style>

